import { useInfiniteQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { InfiniteQueryFunction } from '@frontend/api';

import type {
  SearchPartsByPartNumberData,
  SearchPartsByPartNumberQueryKey,
  UseSearchPartsByPartNumberParams,
} from './types';
import { getSearchPartsByPartNumberQueryKey } from './util';

export const useSearchPartsByPartNumber: InfiniteQueryFunction<
  SearchPartsByPartNumberData,
  [UseSearchPartsByPartNumberParams],
  SearchPartsByPartNumberQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useInfiniteQuery({
    ...queryOptions,
    queryKey: getSearchPartsByPartNumberQueryKey(params),
    queryFn: ({ signal, pageParam }) => {
      return request<SearchPartsByPartNumberData>('/search/part_importer', {
        init: {
          signal,
        },
        query: {
          q: params.partNumber,
          pno: params.isPartNumberOnlySearch,
          root_only: params.isRootPartOnlySearch,
          start: pageParam,
        },
      });
    },
    getNextPageParam: (currentPage, allPages) =>
      currentPage.results.length === 0
        ? undefined
        : allPages.flatMap((page) => page.results).length,
  });
};
